import { render, staticRenderFns } from "./mahjongXmas.vue?vue&type=template&id=12f572d6"
import script from "./mahjongXmas.vue?vue&type=script&lang=js"
export * from "./mahjongXmas.vue?vue&type=script&lang=js"
import style0 from "./mahjongXmas.vue?vue&type=style&index=0&id=12f572d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports